import type { IconContainerProps } from './typings'

import { IconContainer } from './elements/IconContainer'

export function PolylineHide(props: IconContainerProps) {
  return (
    <IconContainer {...props}>
      <svg viewBox="0 0 20 17">
        <path d="M2 9L18 9" stroke="#BBBBBB" stroke-width="2" stroke-linecap="round" />
        <circle cx="2.5" cy="9" r="2" fill="#2A2A2A" />
        <circle cx="17.5" cy="9" r="2" fill="#2A2A2A" />
      </svg>
    </IconContainer>
  )
}
